import { IIncentiveV2Mutations, IIncentiveV2State } from '@/domain/dto/store.incentive-v2.interfaces';
import { IncentiveStep } from 'interfaces';
import { IErrorMessage } from '@/domain/dto/error-message.interface';

export class IncentiveV2Mutations implements IIncentiveV2Mutations {
	private readonly state: IIncentiveV2State;

	public constructor(state: IIncentiveV2State) {
		this.state = state;
	}

	public setStep(step: IncentiveStep): void {
		this.state.step = step;
	}

	public setName(name: string): void {
		this.state.name = name;
	}

	public setEmail(email: string): void {
		this.state.email = email;
	}

	public setPassword(password: string): void {
		this.state.password = password;
	}

	public setConfirmPassword(password: string): void {
		this.state.confirmPassword = password;
	}

	public setAccessToken(accessToken: string | null): void {
		this.state.accessToken = accessToken;
	}

	public setPending(pending: boolean): void {
		this.state.pending = pending;
	}

	public setErrorMessage(errorMessage: IErrorMessage): void {
		this.state.errorMessage = errorMessage;
	}
}
